import { render, staticRenderFns } from "./ProductsSignatureView.vue?vue&type=template&id=3d8cb2c5&scoped=true"
import script from "./ProductsSignatureView.vue?vue&type=script&lang=ts"
export * from "./ProductsSignatureView.vue?vue&type=script&lang=ts"
import style0 from "./ProductsSignatureView.vue?vue&type=style&index=0&id=3d8cb2c5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8cb2c5",
  null
  
)

export default component.exports